import { $Q, $Qll } from '../utils/query-selector';

const initTabs = (container) => {
  // Select the tabs and contents within the specific container (Shopify section)
  const tabs = $Qll('.tab-link', container);
  const contents = $Qll('.tab-content', container);

  if (tabs.length === 0 || contents.length === 0) return; // Exit if there are no tabs or content

  // Activate the first tab and its content by default
  const firstTab = tabs[0];
  const firstContent = $Q(`#${firstTab.dataset.tab}`, container);

  if (firstTab && firstContent) {
    firstTab.classList.add('active');
    firstContent.classList.add('active', 'fade-in');
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      // Remove the 'active' class in all tabs and contents within the current container
      tabs.forEach((t) => t.classList.remove('active'));
      contents.forEach((c) => c.classList.remove('active', 'fade-in', 'fade-out'));

      // Add the 'active' class to the clicked tab and its corresponding content
      tab.classList.add('active');
      const tabContent = $Q(`#${tab.dataset.tab}`, container);

      if (tabContent) {
        // Add fade-out animation to all contents except the target
        contents.forEach((content) => {
          if (content !== tabContent) {
            content.classList.add('fade-out');
          }
        });

        // Add fade-in animation to the target content
        tabContent.classList.add('active', 'fade-in');
      }
    });
  });
};

export default initTabs;
